import { TranscendColor } from '@main/core-ui';
import { NavMenu } from '@main/privacy-center/src/components/NavMenu';
import {
  selectIsLoggedIn,
  selectPrivacyCenterPages,
  selectRequiredPrivacyCenter,
} from '@main/privacy-center/src/containers/App/selectors';
import RequestHistoryPreview from '@main/privacy-center/src/containers/RequestHistoryPreview';
import { RequestHistoryLogin } from '@main/privacy-center/src/containers/RequestHistoryPreview/RequestHistoryLogin';
import SessionManager from '@main/privacy-center/src/containers/SessionManager';
import TakeControl from '@main/privacy-center/src/containers/TakeControl';
import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectActiveDataSubject } from '../ActiveDataSubject/selectors';
import { NoValidScope } from '../NoValidScope';
import { headerMessages } from './messages';
import {
  HeaderWrapper,
  LogoImageWrapper,
  WrapperContents,
  WrapperLogo,
  WrapperNav,
} from './wrappers';

/**
 * The Page Header
 */
export const Header: React.FC = () => {
  const { formatMessage } = useIntl();
  const activeDataSubject = useSelector(selectActiveDataSubject);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const {
    organization: { name: organizationName },
    assets: { logo },
    home,
    showPrivacyRequestButton,
  } = useSelector(selectRequiredPrivacyCenter);
  const takeControlButtonRef = useRef<HTMLButtonElement>(null);
  const links = useSelector(selectPrivacyCenterPages);

  return (
    <HeaderWrapper>
      <NavMenu Wrapper={WrapperNav} links={links} />
      <WrapperLogo href={formatMessage(home)}>
        <LogoImageWrapper
          src={logo ? logo.src : TranscendColor}
          alt={
            logo
              ? formatMessage(logo.alt || headerMessages.organizationLogoAlt, {
                  organizationName,
                })
              : formatMessage(headerMessages.transcendLogoAlt)
          }
        />
      </WrapperLogo>
      {activeDataSubject && (
        <WrapperContents>
          {isLoggedIn ? (
            <RequestHistoryPreview />
          ) : showPrivacyRequestButton ? (
            <RequestHistoryLogin />
          ) : null}
          <TakeControl
            ref={takeControlButtonRef}
            onExited={() => takeControlButtonRef.current?.focus()}
          />
          <SessionManager
            onExited={() => takeControlButtonRef.current?.focus()}
          />
          <NoValidScope />
        </WrapperContents>
      )}
    </HeaderWrapper>
  );
};
